// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2owyK","newExpiryDate":"styles_newExpiryDate__MCVti","footer":"styles_footer__17mqL"};